var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"MLS #"}},[_c('div',{staticClass:"sm:w-1/2"},[_c('input-text',{attrs:{"name":"mls_number","value":_vm.property.mls_number,"placeholder":"#","read_only":_vm.read_only},on:{"change":_vm.fetchMlsData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }